import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNextSlide = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			rx: 4,
			transform: "matrix(-1 0 0 1 24 0)",
			fill: "#524F4E",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.99972 20.25C9.09823 20.2501 9.1958 20.2308 9.28681 20.1931C9.37783 20.1554 9.4605 20.1001 9.53007 20.0303L17.0301 12.5303C17.0997 12.4607 17.155 12.378 17.1927 12.287C17.2304 12.196 17.2498 12.0985 17.2498 12C17.2498 11.9015 17.2304 11.804 17.1927 11.713C17.155 11.622 17.0997 11.5393 17.0301 11.4697L9.53007 3.96965C9.38941 3.829 9.19864 3.74998 8.99972 3.74998C8.8008 3.74998 8.61003 3.829 8.46938 3.96965C8.32872 4.11031 8.2497 4.30108 8.2497 4.5C8.2497 4.69891 8.32872 4.88968 8.46938 5.03034L15.439 12L8.46938 18.9697C8.36448 19.0745 8.29305 19.2082 8.26411 19.3537C8.23517 19.4992 8.25002 19.65 8.30679 19.787C8.36355 19.9241 8.45969 20.0412 8.58303 20.1236C8.70637 20.206 8.85138 20.25 8.99972 20.25Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgNextSlide);
export default ForwardRef;
